import React from "react";

export default ({ width, height, fill }: React.SVGProps<SVGSVGElement>) => (
  <svg width={width || "12"} height={height || "8"} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.585 0.209961L6 4.79496L1.415 0.209961L0 1.62496L6 7.62496L12 1.62496L10.585 0.209961Z" fill={fill || "#4686FA"} />
  </svg>
);
